import React from 'react';
import SharedTable from 'shared/ui/Table';
import { useSelector, useDispatch } from 'react-redux';
import { withBreakpoints } from 'react-breakpoints';
import {
  selectVulnsSelected,
  selectIsFetchingExpandedData,
  selectVulnsGroupedData
} from 'store/Manage/selectors';
import {
  showContextMenu,
  selectRow,
  unSelectAll
} from 'store/Manage/actions';
import { PropTypes } from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { getTrProps, findSelectedVuln } from '../../Functions';
import manageVulnsSchema from '../../schema';

const SubTable = ({ getContext, row }) => {
  const dispatch = useDispatch();
  const rowCount = get(row, 'original.count', 0);
  const vulnsSelected = useSelector(selectVulnsSelected);
  const isFetchingExpandedData = useSelector(selectIsFetchingExpandedData);
  const groupedData = useSelector((state) => selectVulnsGroupedData(state, row.index));

  const selectRowAction = (row) => dispatch(selectRow({}, row));
  const unSelectAllAction = (row) => dispatch(unSelectAll({}, row));
  const showContextMenuAction = (value, xPos, yPos) => dispatch(showContextMenu(value, xPos, yPos));

  const hasGroupedData = !isEmpty(groupedData);
  const emptyState = isFetchingExpandedData ? [''] : [];

  return (
    <SharedTable
      schema={ manageVulnsSchema }
      context={ getContext(hasGroupedData) }
      data={ hasGroupedData ? groupedData : emptyState }
      defaultPageSize={ rowCount }
      hideHeader
      // Legacy bug preserved: isFetching isn't passed, so the context menu also selects the row while fetching.
      getRowProps={ (rowInfo) => getTrProps(rowInfo, vulnsSelected, selectRowAction, unSelectAllAction, showContextMenuAction) }
      isRowSelected={ (rowInfo) => !!findSelectedVuln(rowInfo, vulnsSelected) }
    />
  );
};

SubTable.propTypes = {
  getContext: PropTypes.func.isRequired,
  row: PropTypes.object.isRequired
};

export default withBreakpoints(SubTable);
